export const TOKEN_UPDATE = 'TOKEN_UPDATE';
export function UpdateAuth(value) {
    return {
        type: TOKEN_UPDATE,
        payload: value
    }
}
